import getParsedConfiguration from "./getParsedConfiguration"

export const getParsedEnvironmentVariables = (environmentVariablesValue?: string) => {
    const environmentVariables = String(environmentVariablesValue || "{}")
    return getParsedConfiguration(environmentVariables)
}

export const getEnvironmentVariablesValue = (environmentVariableKey: string) => {
    const allEnvironmentVariables = getParsedEnvironmentVariables(process.env.NEXT_PUBLIC_ENVIRONMENT_VARIABLES);
    return (allEnvironmentVariables[environmentVariableKey] || "")
}

export const getEnvConstantsValue = (environmentVariableKey: string) => {
    const allEnvironmentVariables = getParsedEnvironmentVariables(process.env.NEXT_PUBLIC_ENVCONSTANTS);
    return (allEnvironmentVariables[environmentVariableKey] || "")
}